<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-1">{{ $t(getTitle) }}</h1>
    <!-- form  -->
    <v-card outlined class="mb-4">
      <form @keydown.enter.prevent="submit()">
        <v-card-text class="mt-5">
          <v-row class="mb-0 pb-0">
            <v-col cols="12" md="4">
              <el-text-field
                label="Teisės ID"
                v-model="permission.fft_id"
                hide-details
                required
                cMask="10"
              />
            </v-col>
            <v-col cols="12" md="4">
              <el-text-field
                label="Teisės pavadinimas"
                v-model="permission.fft_pavad"
                :maxlength="150"
                required
              />
            </v-col>
            <v-col cols="12" md="4">
              <el-text-field
                label="Teisės kodas"
                required
                v-model="permission.fft_teis_kodas"
                :maxlength="20"
              />
            </v-col>
            <v-col cols="12">
              <el-text-field
                label="Aprašymas"
                required
                v-model="permission.description"
                :maxlength="200"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row no-gutters>
            <v-spacer></v-spacer>
            <el-button
              class="mr-1"
              color="secondary"
              icon="atšaukti"
              title="Atšaukti"
              @click.native.stop="back()"
              :loading="loading"
            />
            <el-button
              title="Išsaugoti"
              :loading="loading"
              @click.native="saveData()"
              color="primary"
              icon="išsaugoti"
            />
          </v-row>
        </v-card-actions>
      </form>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '@/mixins/userRole'

export default {
  name: 'IpasasFaPermissionForm',

  mixins: [userRole],
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      pageloading: false,
      loading: false,
      formType: undefined,
      permission: {},
    }
  },
  computed: {
    isCreate() {
        return this.formType == 'create'
    },
    getId() {
      return this.$route.params.id || null
    },
    getTitle() {
      if (this.getId) {
        return this.$t(`Redaguoti FA teisę`)
      } else {
        return this.$t(`Nauja FA teisė`)
      }
    },
  },
  beforeDestroy() {},
  created() {
    if (this.getId) {
      this.formType = 'edit'
      this.getData()
    } else {
        this.formType = 'create'
    }
  },
  methods: {
    back() {
      this.$router.push({ name: 'ipasasFaPermissions' })
    },
    getData() {
      this.pageloading = true
      this.$axios
        .get(`ipasas-permissions/fa/${this.getId}`)
        .then((res) => {
          this.permission = res.data.permission
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.pageloading = false
        })
    },
    saveData() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.loading = true
          let formData = new FormData()
          let url = this.isCreate ? `ipasas-permissions/fa` : `ipasas-permissions/fa/${this.permission.id}`
          formData.append('id', this.permission.id || '')
          formData.append('fft_id', this.permission.fft_id || '')
          formData.append('fft_pavad', this.permission.fft_pavad || '')
          formData.append('fft_teis_kodas', this.permission.fft_teis_kodas || '')
          formData.append('description', this.permission.description || '')

           this.$axios
            .post(url, formData)
            .then((res) => {
              this.$root.$emit('DATA_OK_CODE', '000110')
              this.back()
            })
            .catch((err) => {
             this.$root.$emit('DATA_ERROR', err)
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          this.$root.$emit('FORMAT_ERROR')
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped></style>
